import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  getBuildingsList,
  selectState,
  setNewSalesUnitPopover,
} from "../main.slice";
import { useForm } from "react-hook-form";
import { hrsService } from "../../../services/hrs.services";
import { toast } from "react-toastify";
import { ISalesUnitCreate } from "Dashboard/scenes/HighRiseSales/domain/ISalesUnitCreate";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesHRS from "../../../styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";

const NewSalesUnitPopover = () => {
  const dispatch = useAppDispatch();

  const { expandedBuilding } = useSelector(selectState);

  const close = () => {
    dispatch(setNewSalesUnitPopover({ isOpen: false }));
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ISalesUnitCreate>();

  const onSubmit = async (data: ISalesUnitCreate) => {
    try {
      var buildingId = expandedBuilding;
      var createData = { buildingId, ...data };
      await hrsService.createSalesUnit(createData);
      dispatch(getBuildingsList({}));
      toast.success("Prodajna jedinica je uspešno dodata.");
      close();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`${classes.basicPopover} ${classesHRS.newBuildingPopover}`}>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>naziv prodajne jedinice</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.fullName ? classes.itemError : ""}`}
            {...register("fullName", { required: true })} />
        </div>
      </div>
      <div className={`${classes.row}
        ${errors.squareMeters ? classes.itemError : ""}`}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>kvadratura</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.squareMeters ? classes.itemError : ""}`}
            {...register("squareMeters", { required: true })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewSalesUnitPopover;
